import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { colours } from "utils";
import { CXL, H2 } from "@/components/Typography";
import Device from "@/utils/device";
import Image from "next/image";

const LoungeContent: FunctionComponent = () => {
  return (
    <S.Section data-cy="SF-content-2023">
      <H2>
        <S.BoldWrap>
          The AllBright <br />
        </S.BoldWrap>
        <S.ItalicWrap>Lounge</S.ItalicWrap>
      </H2>
      <S.GridContainer>
        <S.CopyContainer>
          <CXL>
            Opening in March 2025, the AllBright Lounge at Old Sessions House is
            a welcoming, women-only space for members, designed to bring the
            AllBright community closer together.
          </CXL>
          <CXL>
            Whether you're enjoying a coffee, joining industry meet-ups, or
            connecting with fellow members, this vibrant space is all about
            building meaningful relationships and sparking ideas.
          </CXL>
          <CXL>
            With communal co-working tables, cozy seating areas, phone booths,
            and quiet spots for solo work, the lounge will be your new home away
            from home.
          </CXL>
        </S.CopyContainer>
        <S.ImageContainer>
          <Image
            src="/images/old-sessions-house/lady-smiling.jpg"
            alt=""
            layout="fill"
            objectFit="cover"
          />
        </S.ImageContainer>
      </S.GridContainer>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  position: relative;
  width: 100%;
  padding: 10% 10% 0 10%;
  background: ${colours.shell};
  display: flex;
  flex-direction: column;
  gap: 30px;

  > ${H2} {
    font-size: 3rem;
    line-height: 3rem;
  }

  @media ${Device.mobile} {
    > ${H2} {
      font-size: 4rem;
      line-height: 4rem;
    }
  }

  @media ${Device.tablet} {
    padding: 5% 10%;

    > ${H2} {
      font-size: 6rem;
      line-height: 6rem;
    }
  }
`;

S.FontWeightWrap = styled.span`
  font-weight: 100;
`;

S.CopyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

S.GridContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 30px;

  @media ${Device.desktop} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 30px;
  }
`;

S.ImageContainer = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  aspect-ratio: 2/1;

  @supports not (aspect-ratio: 2/1) {
    &::before {
      float: left;
      padding-top: 50%;
      content: "";
    }
    &::after {
      display: block;
      content: "";
      clear: both;
    }
  }

  @media (min-width: ${Device.desktop}) {
    aspect-ratio: 2/1;

    @supports not (aspect-ratio: 1/1.2) {
      &::before {
        float: left;
        padding-top: 120%;
        content: "";
      }
      &::after {
        display: block;
        content: "";
        clear: both;
      }
    }
  }
`;

S.ItalicWrap = styled.span`
  font-style: italic;
  font-family:
    Roxborough CF,
    sans-serif;
  font-weight: 100;
`;

S.BoldWrap = styled.span`
  font-weight: 600;
`;

export default LoungeContent;
